
export const common = {
  // Navigation
  'nav.home': 'Startseite',
  'nav.treatments': 'Behandlungen',
  'nav.howItWorks': 'Wie es funktioniert',
  'nav.supervision': 'Überwachung',
  'nav.about': 'Über uns',
  'nav.bookNow': 'Jetzt buchen',
  'nav.language': 'Sprache',

  // Hero
  'hero.badge': 'Echte Ärzte. Echte Pflege. Echte Seelenruhe.',
  'hero.title.line1': 'Sie verdienen ein Lächeln,',
  'hero.title.line2': 'auf das Sie stolz sind',
  'hero.subtitle1': 'Ob es Schmerzen sind, die Sie ignoriert haben, ein Lächeln, das Sie versteckt haben, oder Kosten, die Sie warten ließen — Sie müssen nicht länger warten.',
  'hero.subtitle2': 'Wir machen erstklassige Zahnpflege in der Türkei sicher, unterstützt und vollständig erreichbar — mit einem Arzt, der jeden Schritt überwacht.',
  'hero.cta.primary': 'Meine Reise beginnen',
  'hero.cta.secondary': 'Zuerst mit jemandem sprechen',
  'hero.feature1': 'Von Anfang bis Ende ärztlich überwacht',
  'hero.feature2': 'Pflege, die zu Ihrem Leben und Budget passt',
  'hero.feature3': 'Bei jedem Schritt unterstützt, nah oder fern',

  // Services
  'services.badge': 'Ihre Reise beginnt hier',
  'services.title': 'Behandlungen, die Ihren Alltag verändern',
  'services.subtitle': 'Ob Sie bereit sind, ohne Zögern zu lächeln, ohne Sorgen zu essen oder sich einfach wieder wie Sie selbst zu fühlen — wir sind hier, um Ihnen zu helfen',
  'services.cta': 'Alle Behandlungen erkunden',
  'services.swipeHint': 'Wischen Sie, um weitere Behandlungen zu erkunden',
  'services.learnMore': 'Mehr erfahren',
  'services.startingFrom': 'Ab',
  'services.perTooth': 'pro Zahn',

  // Service: Dental Implants
  'service.implants.title': 'Zahnimplantate',
  'service.implants.desc': 'Essen, lachen und sprechen Sie wieder mit vollem Vertrauen. Fühlen Sie sich wie Sie selbst mit Zähnen, die aussehen, sich anfühlen und funktionieren wie Ihre natürlichen.',
  // Service: Veneers
  'service.veneers.title': 'Porzellanveneers',
  'service.veneers.desc': 'Hören Sie auf, Ihr Lächeln auf Fotos zu verstecken. Wachen Sie jeden Tag auf und lieben Sie, was Sie im Spiegel sehen, mit einem Lächeln, das sich endlich wie Sie anfühlt.',

  // Service: Smile Makeover
  'service.smile.title': 'Smile Makeover',
  'service.smile.desc': 'Verändern Sie, wie Sie sich selbst fühlen. Ein komplettes Lächeln-Makeover, das um Ihr Gesicht, Ihr Leben und das Selbstvertrauen, das Sie verdienen, gestaltet ist.',

  // Service: Orthodontics
  'service.orthodontics.title': 'Kieferorthopädie',
  'service.orthodontics.desc': 'Begradigen Sie Ihre Zähne ohne Selbstbewusstsein. Diskrete Behandlung, die zu Ihrem Lebensstil passt und Ihnen das Lächeln gibt, das Sie schon immer wollten.',

  // Service: Whitening
  'service.whitening.title': 'Zahnaufhellung',
  'service.whitening.desc': 'Fühlen Sie sich in jedem Gespräch selbstbewusst. Ein helleres, weißeres Lächeln, das Sie sich jedes Mal gut fühlen lässt, wenn Sie sprechen.',

  // Service: Root Canal
  'service.root.title': 'Wurzelkanalbehandlung',
  'service.root.desc': 'Hören Sie auf, mit Zahnschmerzen zu leben. Retten Sie Ihren natürlichen Zahn und genießen Sie das Leben wieder ohne ständige Beschwerden oder Sorgen.',

  // Service: Crowns
  'service.crowns.title': 'Zahnkronen',
  'service.crowns.desc': 'Schützen und restaurieren Sie beschädigte Zähne, damit Sie wieder essen können, was Sie lieben. Starke, natürlich aussehende Kronen, die Jahre halten.',

  // Service: All-on-4
  'service.allon4.title': 'All-on-4 Implantate',
  'service.allon4.desc': 'Holen Sie sich Ihr Leben an nur einem Tag zurück. Ein vollständiger Satz permanenter Zähne, mit denen Sie essen, lächeln und ohne Grenzen oder Verlegenheit leben können.',

  // How It Works
  'how.badge': 'Einfacher Prozess',
  'how.title': 'Wie es funktioniert',
  'how.subtitle': 'Vier einfache Schritte zu erstklassiger Zahnpflege mit vollständiger Transparenz',
  'how.cta': 'Ihre Reise beginnen',

  'how.step1.number': '01',
  'how.step1.title': 'Buchen Sie Ihre Behandlung',
  'how.step1.desc': 'Wählen Sie Ihre Zahnbehandlung und laden Sie Ihre Röntgenbilder oder Scans hoch. Unser Team wird prüfen und einen personalisierten Behandlungsplan erstellen.',

  'how.step2.number': '02',
  'how.step2.title': 'Überwachung wählen',
  'how.step2.desc': 'Wählen Sie Ihre bevorzugte Überwachungsoption: unabhängiger Drittarzt, Ihr eigener Zahnarzt (erhält 10%) oder unser hauseigener Experte.',

  'how.step3.number': '03',
  'how.step3.title': 'Behandlung mit Transparenz erhalten',
  'how.step3.desc': 'Erhalten Sie Ihre Behandlung in unserer JCI-akkreditierten Klinik. Ihr gewählter Supervisor überprüft alle Röntgenbilder, Scans und Behandlungsfortschritte in Echtzeit.',

  'how.step4.number': '04',
  'how.step4.title': 'Nachsorge',
  'how.step4.desc': 'Setzen Sie die Pflege mit Ihrem Zahnarzt fort, der vollständige Kenntnis Ihrer Behandlung hat. Wir stellen alle Unterlagen und kontinuierliche Unterstützung bereit.',

  // Supervision
  'supervision.badge': 'Sie sind bei jedem Schritt geschützt',
  'supervision.title': 'Besorgt über Zahnpflege im Ausland?',
  'supervision.subtitle': 'Diese Sorge ist völlig berechtigt — und genau deshalb haben wir dies aufgebaut. Jeder Patient erhält einen dedizierten Supervisor, der seine Behandlung vom ersten bis zum letzten Tag überwacht.',
  'supervision.swipeHint': 'Wischen Sie, um Optionen zu erkunden',
  'supervision.chooseOption': 'Wählen Sie diese Option bei der Buchung',

  'supervision.option1.title': 'Unabhängiger Drittarzt',
  'supervision.option1.badge': 'Am vertrauenswürdigsten',
  'supervision.option1.desc': 'Jemand in Ihrer Ecke, der nur Ihnen antwortet — nicht der Klinik. Sie überprüfen jeden Scan, genehmigen jeden Schritt und stellen sicher, dass nichts übersehen wird.',
  'supervision.option1.feature1': 'Überprüft Ihre Röntgenbilder, bevor etwas beginnt',
  'supervision.option1.feature2': 'Genehmigt Ihren Behandlungsplan unabhängig',
  'supervision.option1.feature3': 'Überprüft in jeder Phase Ihrer Pflege',
  'supervision.option1.feature4': 'Bestätigt, dass das Endergebnis dem Standard entspricht',
  'supervision.option1.feature5': 'Null Interessenkonflikt — sie arbeiten für Sie',
  'supervision.option1.pricing': 'Was Sie bekommen: Vollständige unabhängige Überwachung',

  'supervision.option2.title': 'Ihr eigener Zahnarzt zu Hause',
  'supervision.option2.badge': 'Am komfortabelsten',
  'supervision.option2.desc': 'Der Zahnarzt, dem Sie bereits vertrauen, bleibt Teil Ihrer Reise. Sie kennen Ihre Geschichte, sie kennen Sie — und bleiben bei jedem Schritt informiert.',
  'supervision.option2.feature1': 'Ihr Zahnarzt erhält alle Unterlagen und Scans',
  'supervision.option2.feature2': 'Wird in jeder Behandlungsphase auf dem Laufenden gehalten',
  'supervision.option2.feature3': 'Übernimmt Ihre Nachsorge zu Hause',
  'supervision.option2.feature4': 'Verdient 10% der Behandlungskosten für seine Zeit',
  'supervision.option2.feature5': 'Nahtlose Kontinuität — kein Neuanfang',
  'supervision.option2.pricing': 'Was Sie bekommen: Vertraute Pflege, keine Lücken',

  'supervision.option3.title': 'Unser hauseigener Experte',
  'supervision.option3.badge': 'Inbegriffen',
  'supervision.option3.desc': 'Ein leitender Spezialist mit über 15 Jahren Erfahrung überwacht Ihre Behandlung vor Ort. Sie sind nie nur ein Patient — Sie sind eine Priorität.',
  'supervision.option3.feature1': 'Über 15 Jahre Spezialistenerfahrung',
  'supervision.option3.feature2': 'Während Ihrer gesamten Pflege in der Klinik anwesend',
  'supervision.option3.feature3': 'Reagiert sofort, wenn sich etwas nicht richtig anfühlt',
  'supervision.option3.feature4': 'Hält jeden Schritt auf höchstem Niveau',
  'supervision.option3.feature5': 'Bereits enthalten — keine zusätzlichen Kosten für Sie',
  'supervision.option3.pricing': 'Was Sie bekommen: Expertenaugen, immer präsent',

  'supervision.why.title': 'Sie sollten nicht einfach auf das Beste hoffen müssen',
  'supervision.why.desc': 'Ins Ausland für eine Zahnbehandlung zu gehen erfordert Mut. Sie vertrauen Menschen, die Sie nie getroffen haben, in einem Land, das Sie vielleicht nicht kennen, mit etwas so Persönlichem wie Ihrem Lächeln. Wir haben unser Überwachungssystem aufgebaut, weil wir glauben, dass Sie mehr als ein Versprechen verdienen — Sie verdienen eine echte Person, die jede Entscheidung über Ihre Pflege überwacht. Keine Checkliste. Keine Broschüre. Ein Mensch, der Ihnen gegenüber verantwortlich ist.',

  // CTA
  'cta.title.line1': 'Ihr Lächeln hat',
  'cta.title.line2': 'Lange genug gewartet',
  'cta.subtitle1': 'Wir wissen, dass es nicht einfach ist, diesen Schritt zu machen. Die Unsicherheit, die Fragen, die "Was wäre wenn" — wir hören sie jeden Tag. Genau deshalb sind wir hier.',
  'cta.subtitle2': 'Ihr erstes Gespräch ist kostenlos, druckfrei und vollständig zu Ihren Bedingungen. Sprechen Sie einfach mit uns — wir kümmern uns um den Rest.',
  'cta.button.primary': 'Ich bin bereit zu sprechen',
  'cta.button.secondary': 'Auf WhatsApp chatten',
  'cta.badge1': 'Echte Ärzte. Echte Pflege.',
  'cta.badge2': 'Kein Druck. Keine Eile.',
  'cta.badge3': 'Sie werden bei jedem Schritt unterstützt.',
  'cta.badge4': 'Echte Ergebnisse. Echte Menschen.',

  // Footer
  'footer.brand.desc': 'Wir glauben, dass jeder es verdient, sich in seinem Lächeln selbstbewusst zu fühlen. Wir sind hier, um das möglich zu machen — sicher, ehrlich und mit einem echten Arzt an Ihrer Seite.',
  'footer.cta': 'Beratung buchen',
  'footer.treatments': 'Behandlungen',
  'footer.company': 'Unternehmen',
  'footer.resources': 'Ressourcen',
  'footer.phone': 'Telefon',
  'footer.email': 'E-Mail',
  'footer.location': 'Standort',
  'footer.locationValue': 'Istanbul, Türkei',
  'footer.copyright': '© {{year}} Plexus Alliance. Alle Rechte vorbehalten.',
  'footer.poweredBy': 'Unterstützt von Readdy',

  // About page
  'about.hero.badge': 'Unsere Geschichte',
  'about.hero.title': 'Wir haben das Sicherheitsnetz gebaut, das dem Zahntourismus fehlte',
  'about.hero.subtitle': 'Plexus Alliance wurde auf einer einfachen Überzeugung gegründet: Patienten verdienen eine unabhängige Stimme in ihrer eigenen Behandlung — besonders wenn sie weit von zu Hause entfernt sind.',
  'about.mission.badge': 'Unsere Mission',
  'about.mission.title': 'Transparente, überwachte Zahnpflege für jeden Patienten, überall.',
  'about.mission.desc': 'Wir verbinden Patienten mit erstklassigen Zahnkliniken in Istanbul und bieten dabei die unabhängige Überwachungsschicht, die die meisten Zahntourismusunternehmen einfach nicht anbieten.',
  'about.values.badge': 'Wofür wir stehen',
  'about.values.title': 'Unsere Grundwerte',
  'about.value1.title': 'Unabhängigkeit',
  'about.value1.desc': 'Unsere Supervisoren antworten nur Ihnen — nie der Klinik.',
  'about.value2.title': 'Transparenz',
  'about.value2.desc': 'Jede Akte, jeder Scan, jede Entscheidung — für Sie vollständig sichtbar.',
  'about.value3.title': 'Kontinuität',
  'about.value3.desc': 'Ihre Pflege hört nicht auf, wenn Sie ins Flugzeug steigen.',
  'about.value4.title': 'Zugänglichkeit',
  'about.value4.desc': 'Erstklassige Zahnpflege sollte kein Privileg sein. Wir machen sie erreichbar.',

  // Treatments page
  'treatments.hero.badge': 'Alle Behandlungen',
  'treatments.hero.title': 'Finden Sie Ihre Behandlung',
  'treatments.hero.subtitle': 'Von einzelnen Implantaten bis zu kompletten Lächeln-Makeovers — jede Behandlung ist überwacht, transparent und fair bepreist.',
  'treatments.filter.all': 'Alle Behandlungen',
  'treatments.filter.implants': 'Implantate',
  'treatments.filter.cosmetic': 'Kosmetisch',
  'treatments.filter.orthodontics': 'Kieferorthopädie',
  'treatments.filter.restorative': 'Restaurativ',
  'treatments.cta.title': 'Nicht sicher, welche Behandlung Sie benötigen?',
  'treatments.cta.desc': 'Sagen Sie uns, was Sie stört — wir prüfen Ihren Fall kostenlos und empfehlen den richtigen Weg.',
  'treatments.cta.button': 'Kostenlose Bewertung erhalten',

  // Book Treatment page
  'book.hero.badge': 'Starten Sie Ihre Reise',
  'book.hero.title': 'Buchen Sie Ihre Behandlung',
  'book.hero.subtitle': 'Füllen Sie die Details unten aus und wir melden uns innerhalb weniger Stunden mit einem personalisierten Plan.',
  'book.form.name': 'Vollständiger Name',
  'book.form.email': 'E-Mail-Adresse',
  'book.form.phone': 'Telefon / WhatsApp',
  'book.form.treatment': 'Gewünschte Behandlung',
  'book.form.supervision': 'Überwachungspräferenz',
  'book.form.message': 'Erzählen Sie uns mehr (optional)',
  'book.form.submit': 'Meine Anfrage senden',
  'book.form.submitting': 'Wird gesendet...',
  'book.form.success': 'Anfrage gesendet! Wir melden uns innerhalb weniger Stunden.',

  // Partner Registration page
  'partner.hero.badge': 'Partner werden',
  'partner.hero.title': 'Treten Sie dem Plexus Alliance Netzwerk bei',
  'partner.hero.subtitle': 'Sind Sie Zahnarzt, Klinik oder Gesundheitsfachkraft? Werden Sie Partner und verdienen Sie, während Sie Ihren Patienten helfen, erstklassige Versorgung zu erhalten.',
  'partner.form.submit': 'Bewerbung einreichen',

  // How It Works page
  'hiw.hero.badge': 'Der Prozess',
  'hiw.hero.title': 'Wie es funktioniert',
  'hiw.hero.subtitle': 'Von Ihrer ersten Nachricht bis zur letzten Kontrolle — hier ist genau, was passiert, Schritt für Schritt.',
  'hiw.faq.title': 'Haben Sie noch Fragen?',
  'hiw.cta.title': 'Bereit, den ersten Schritt zu machen?',
  'hiw.cta.subtitle': 'Es beginnt mit einer einzigen Nachricht. Sagen Sie uns, was Sie brauchen — wir kümmern uns um den Rest.',
  'hiw.cta.button': 'Meine Reise beginnen',

  // Supervision page
  'sup.hero.badge': 'Ihr Schutz',
  'sup.hero.title': 'Medizinische Überwachung',
  'sup.hero.subtitle': 'Das Einzige, was die meisten Zahntourismusunternehmen nicht anbieten — und das Einzige, das den ganzen Unterschied macht.',
  'sup.why.title': 'Die meisten Kliniken arbeiten für sich selbst. Wir arbeiten für Sie.',
  'sup.options.title': 'Drei Wege, geschützt zu bleiben',
  'sup.pillars.title': 'Was jeder überwachte Patient erhält',
  'sup.compare.title': 'Mit Überwachung vs. ohne',
  'sup.faq.title': 'Fragen zur Überwachung',
  'sup.cta.title': 'Ihre Gesundheit verdient eine unabhängige Stimme.',
  'sup.cta.button': 'Mit Überwachung buchen',

  // Common UI
  'common.learnMore': 'Mehr erfahren',
  'common.bookNow': 'Jetzt buchen',
  'common.startJourney': 'Meine Reise beginnen',
  'common.getStarted': 'Loslegen',
  'common.contactUs': 'Kontaktieren Sie uns',
  'common.readMore': 'Weiterlesen',
  'common.viewAll': 'Alle anzeigen',
  'common.close': 'Schließen',
  'common.back': 'Zurück',
  'common.next': 'Weiter',
  'common.loading': 'Wird geladen...',
  'common.error': 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
  'common.required': 'Dieses Feld ist erforderlich',
  'common.optional': 'Optional',
  'common.saving': 'Ersparnis von',
  'common.perTooth': 'pro Zahn',
  'common.included': 'Inbegriffen',
  'common.mostTrusted': 'Am vertrauenswürdigsten',
  'common.mostComfortable': 'Am komfortabelsten',
  'common.yearsExperience': 'Jahre Erfahrung',
  'common.patients': 'Patienten',
  'common.countries': 'Länder',
  'common.savings': 'Ersparnis',
};

export default common;
